"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activateFormsFailure = exports.activateFormsSuccess = exports.activateFormsRequest = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = void 0;
const ActionTypes = require("../../actionTypes/sokosite/activatedForms");
function fetchRequest(projectId) {
    return {
        type: ActionTypes.FETCH_REQUEST,
        projectId
    };
}
exports.fetchRequest = fetchRequest;
function fetchSuccess(payload, projectId) {
    return {
        type: ActionTypes.FETCH_SUCCESS,
        payload,
        projectId
    };
}
exports.fetchSuccess = fetchSuccess;
function fetchFailed(payload, projectId) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload,
        projectId
    };
}
exports.fetchFailed = fetchFailed;
function activateFormsRequest(payload) {
    return {
        type: ActionTypes.ACTIVATE_FORMS_REQUEST,
        payload
    };
}
exports.activateFormsRequest = activateFormsRequest;
function activateFormsSuccess(payload, projectId) {
    return {
        type: ActionTypes.ACTIVATE_FORMS_SUCCESS,
        payload,
        projectId
    };
}
exports.activateFormsSuccess = activateFormsSuccess;
function activateFormsFailure(payload, projectId) {
    return {
        type: ActionTypes.ACTIVATE_FORMS_FAILURE,
        payload,
        projectId
    };
}
exports.activateFormsFailure = activateFormsFailure;
//# sourceMappingURL=activatedForms.js.map